import {FlexAlign, FlexJustify, StackHorizontal, useTranslation} from "@twigsby/frontend-framework";
import React from "react";

const TopUp = () => {
    const { t } = useTranslation();

    return (
        <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-xs'}>
            <h2 className={'mb-0'}>{t('settings.topUp.title')}</h2>
        </StackHorizontal>
    )
}

export { TopUp }

